module.exports = __webpack_public_path__ + "img/menu_omega_platform.5ee64585.png";